<template>
  <div class="DropdownGptSharingItem">
    <div class="DropdownGptSharingItem__icon-container">
      <UIIcon
        :name="icon"
        class="DropdownGptSharingItem__icon"
        :class="{
          'DropdownGptSharingItem__icon--default-color': icon === 'lock',
        }"
      />
    </div>

    <div class="DropdownGptSharingItem__info">
      <div class="DropdownGptSharingItem__info-label">
        {{ label }}
      </div>

      <p class="DropdownGptSharingItem__description">
        {{ description }}
      </p>
    </div>

    <div v-if="isSelected" class="DropdownGptSharingItem__selected-container">
      <UIIcon class="DropdownGptSharingItem__selected-icon" name="check" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IIcons } from '@/views/components/ui/icons/types'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

defineProps<{
  label: string
  description: string
  icon: IIcons
  isSelected?: boolean
}>()
</script>

<style scoped lang="scss">
.DropdownGptSharingItem {
  display: flex;
  border-radius: 4px;
  cursor: pointer;
  gap: 0.5rem;
  position: relative;
  width: 100%;

  .DropdownGptSharingItem__icon-container {
    background-color: var(--bg-elevated-primary, var(--bg-primary));
    border-radius: 50%;
    border: 1px solid var(--border-default);
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .DropdownGptSharingItem__icon {
    --size: 1.25rem;
    --color: var(--icon-accent);

    // The private option's lock stays muted: it is the default, not a choice.
    &.DropdownGptSharingItem__icon--default-color {
      --color: var(--icon-tertiary);
    }
  }

  .DropdownGptSharingItem__info-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--text-primary);
    font-weight: 400;
  }

  .DropdownGptSharingItem__label {
    font-weight: 400;
  }

  .DropdownGptSharingItem__description {
    @include font-size-12px;
    color: var(--text-tertiary);
    display: inline-block;
    align-items: center;
    text-align: start;
  }

  .DropdownGptSharingItem__selected-container {
    position: absolute;
    top: 0;
    right: 0;
    background-color: var(--interactive-bg-primary-default);
    width: 1rem;
    min-width: 1rem;
    height: 1rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .DropdownGptSharingItem__selected-icon {
    --color: var(--interactive-icon-primary-default);
    --size: 0.5rem;
  }
}
</style>
